import { ChangeEvent } from 'react';

import { FormControl, Switch, Typography } from '@mui/material';

export type ClaimValueCustomSwitchFieldProps = {
    value: boolean | undefined,
    changeHandler: ((event: ChangeEvent<HTMLInputElement>, checked: boolean) => void)
};

export function ClaimValueCustomSwitchField({
    value,
    changeHandler
}: Readonly<ClaimValueCustomSwitchFieldProps>) {
    return (
        <FormControl
            style={{ flexDirection: 'row', alignItems: 'center' }}
        >
            <Typography style={{ marginRight: '70px' }}>Claim Value:</Typography>
            False
            <Switch
                checked={value}
                onChange={changeHandler}
            />
            True
        </FormControl>
    );
}
